export default __webpack_public_path__ + "static/media/Dorothy-Betty-Grace and Cliff.14e27a1b.jpg";